import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Eye, EyeOff } from "lucide-react";

const inputCls =
  "w-full px-4 py-3 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#F5B301] placeholder:text-slate-400";

export default function ClubeLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setErro("");
    setLoading(true);
    try {
      const r = await api.post("/indicadores/login", { email: email.trim(), senha });
      localStorage.setItem("ind_token", r.data.token);
      navigate("/clube/painel");
    } catch (err) {
      setErro(err.response?.data?.detail || "Não foi possível entrar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-6" data-testid="clube-login">
      <div className="w-full max-w-sm">
        <img src="/logo.jpg" alt="Carlos Jr Fretes e Mudanças" className="h-16 w-auto object-contain rounded-xl bg-white p-1 mb-6 mx-auto border border-slate-100" />
        <h1 className="font-heading text-xl font-bold text-navy text-center">Clube de Indicadores</h1>
        <p className="text-xs text-slate-500 text-center mt-1">Entre com o e-mail e a senha cadastrados</p>
        <form onSubmit={submit} className="mt-6 bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">E-mail</label>
            <input
              type="email"
              data-testid="clube-login-email"
              className={`${inputCls} mt-1`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Senha</label>
            <div className="relative mt-1">
              <input
                type={show ? "text" : "password"}
                data-testid="clube-login-senha"
                className={`${inputCls} pr-11`}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <button
                type="button"
                data-testid="clube-login-eye"
                onClick={() => setShow((s) => !s)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
                aria-label={show ? "Ocultar senha" : "Mostrar senha"}
              >
                {show ? <EyeOff className="w-[18px] h-[18px]" /> : <Eye className="w-[18px] h-[18px]" />}
              </button>
            </div>
          </div>
          {erro && <p className="text-xs text-red-500 font-medium" data-testid="clube-login-erro">{erro}</p>}
          <button
            type="submit"
            data-testid="clube-login-btn"
            disabled={loading}
            className="w-full py-3.5 rounded-xl bg-navy text-white font-extrabold text-sm active:scale-95 transition-transform disabled:opacity-50"
          >
            {loading ? "ENTRANDO..." : "ENTRAR"}
          </button>
          <Link to="/clube/recuperar" className="block text-center text-xs text-navy font-semibold underline" data-testid="clube-esqueci-link">
            ESQUECI MINHA SENHA
          </Link>
        </form>
        <div className="text-center mt-4 space-y-2">
          <Link to="/clube/cadastro" className="block text-xs text-slate-500 underline" data-testid="clube-login-cadastro">
            Ainda não sou indicador — quero me cadastrar
          </Link>
          <Link to="/clube" className="block text-xs text-slate-400 underline" data-testid="clube-login-voltar">
            Voltar
          </Link>
        </div>
      </div>
    </div>
  );
}
